export const FOLDER_DRAG = 'application/x-fokus-folder-id';
export const FOLDER_DRAG_IDS = 'application/x-fokus-folder-ids';
export const DOC_DRAG = 'application/x-fokus-doc-id';

/** Synthetic Atlas node for docs that are not in any folder. Not persisted. */
export const ATLAS_UNFILED_ID = '__atlas_unfiled__';

export const isAtlasUnfiledId = (id) => id === ATLAS_UNFILED_ID;

/** Drop target → real parent id (`null` = library root). */
export const atlasDropParentId = (id) => (isAtlasUnfiledId(id) ? null : id);

export const readDraggedFolderIds = (dataTransfer) => {
  const raw = dataTransfer.getData(FOLDER_DRAG_IDS);
  if (raw) {
    try {
      const ids = JSON.parse(raw);
      if (Array.isArray(ids)) return ids.filter(Boolean);
    } catch (_) {
      /* fall through */
    }
  }
  const one = dataTransfer.getData(FOLDER_DRAG);
  return one ? [one] : [];
};
